import React from "react";
import { NavLink } from "react-router-dom";

const Routing = () => {
  return (
    <div>
      <div className="container mx-auto pt-24 md:pt-36 pb-12 px-5 text-black">
        <div className="flex flex-col gap-3 mb-7 md:pl-10">
          <div className="flex items-center justify-between">
            <div className="flex items-center text-4xl font-bold head gap-3 ">
              <span className=""> ROUTES</span>
              <div className="h-2 w-4 bg-black"></div>
            </div>
            <NavLink
              to="/terminal"
              className="bg-[#B9000A] text-white font-bold text-base p-2 px-4"
            >
              Go to Terminals
            </NavLink>
          </div>
          <div className="text text-lg md:w-[55%]">
            Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do
            eiusmod tempor incididunt ut labore et dolore magna aliqua.
          </div>
        </div>
      </div>
    </div>
  );
};

export default Routing;
